import React, {useEffect, useState} from "react";

import {makeStyles} from "@material-ui/core/styles";
import {Box, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow} from "@material-ui/core";
import styleConstants from "../../../constants/styleConstants";

import {getDiscountList} from "../api";
import Layout from "../../../components/layout";
import Filters from "./Filters";
import EmptyOrShow from "../../../components/EmptyOrShow";
import {getDateCalendar} from "../../../utils";
import TableRowComp from "./TableRowComp";
import NumberFormat from "react-number-format";

const headTitle = ["Наименование", "Тип", "Количество"];

const Discount = () => {
  const classes = useStyles();
  const [contractArr, setContractArr] = useState([]);
  const [stateSum, setStateSum] = useState({});
  const [filters, setFilters] = useState({
    sale_department_id: null,
    sale_type_code: null,
    date_begin: getDateCalendar(1),
    date_end: getDateCalendar()
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getDiscountList(filters)
      .then(res => {
        setContractArr(res);
        setStateSum({
          cnt: res?.reduce((a, b) => a + b.cnt, 0)
        });
      })
      .catch(() => {
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filters]);

  return (
    <Layout title="Отчет по скидкам">
      <Box sx={{ padding: "45px 20px 20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "20px",
            padding: "20px 0"
          }}
        >
          <Filters state={filters} setState={setFilters} />
        </Box>
        <EmptyOrShow loading={loading}>
          <TableContainer className={classes.table_container}>
            <Table
              size="small"
              stickyHeader
              aria-label="sticky table"
              className={classes.table}
            >
              <TableHead className={classes.table_head}>
                <TableRow>
                  {headTitle.map(el => {
                    return <TableCell key={el}>{el}</TableCell>;
                  })}
                </TableRow>
              </TableHead>
              <TableBody className={classes.table_body}>
                {contractArr?.map(el => {
                  return <TableRowComp key={el.discount_id} {...el} />;
                })}
              </TableBody>
              <TableFooter className={classes.table_footer}>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>Итого</TableCell>
                  <TableCell />
                  <TableCell>
                    <NumberFormat
                      value={stateSum?.cnt}
                      displayType="text"
                      thousandSeparator={" "}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </EmptyOrShow>
      </Box>
    </Layout>
  );
};

export default Discount;
const useStyles = makeStyles({
  table_container: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "4px",
    width: "60% !important",
    // height: "calc(100vh - 160px)",

    "&::-webkit-scrollbar": {
      width: 8
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: styleConstants.primaryColor,
      borderRadius: styleConstants.borderRadius
    }
  },
  table_head: {
    "& th": {
      fontSize: "12px",
      fontWeight: 600,
      color: "#111",
      backgroundColor: "#fff",
      borderBottom: "1px solid #ccc !important"
    }
  },
  table_body: {
    "& tr": {
      transition: "0.4s",
      "&:hover": {
        background: "#d3d3d36e"
      }
    },
    "& td": {
      borderTop: "none !important",
      borderBottom: "1px solid #ccc !important",
      borderLeft: "none !important"
    }
  },
  table_footer: {
    "& td": {
      fontSize: 14,
      fontWeight: "bold",
      color: "black",
      backgroundColor: "#fff",
      borderTop: "1px solid #f0f2f6 !important"
    }
  }
});
